import { render, staticRenderFns } from "./map-bottom-point-cloud.vue?vue&type=template&id=481e75a8"
import script from "./map-bottom-point-cloud.vue?vue&type=script&lang=js"
export * from "./map-bottom-point-cloud.vue?vue&type=script&lang=js"
import style0 from "./map-bottom-point-cloud.vue?vue&type=style&index=0&id=481e75a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports